import Unicon from '../../components/base/Unicon';

const Stat = ({ stat }) => {
  return (
    <div className="d-flex align-items-center">
      <Unicon icon={stat.icon} size={40} className={`text-${stat.iconColor}`} />
      <div className="ms-2">
        <div className="d-flex align-items-end">
          <h2 className="mb-0 me-2">{stat.count ?? 0}</h2>
          <span className="fs-7 fw-semi-bold text-900">{stat.title}</span>
        </div>
        <p className="text-800 fs-9 mb-0">{stat.subtitle}</p>
      </div>
    </div>
  );
};

export default Stat;
